import React from "react";
import { Navigate } from "react-router-dom";
import PrintLayout from "../components/PrintLayout";

// Define a custom hook to check authentication
const useAuth = () => {
  const userData = localStorage.getItem("user"); // You can adjust the key as per your setup
  return userData;
};

const PrivateRoutePrinter = ({ children, component: Component, ...rest }) => {
  const userData = useAuth();
  // If authenticated, render the provided component
  return userData ? <PrintLayout /> : <Navigate to="/login" />;
};
export default PrivateRoutePrinter;
